import { GoalType } from 'models/set';

export const getContentTypeDisplayName = (goalType: GoalType, short?: boolean): string => {
  switch (goalType) {
    case 'set':
      return short ? 'Set' : 'Learning Set';
    case 'assessment':
      return 'Assessment';
    case 'survey':
      return 'Survey';
    case 'scorm':
      return 'SCORM';
  }
};